import EditSkillModal from './EditSkillModal'

export default EditSkillModal
